// extracted by mini-css-extract-plugin
export default {"container":"_1d6V+F+h","main":"_8PySjBnP"};